import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { COLOR_BORDER } from '@assets/color';

const blurBoxStyle = `
  box-shadow: 0 0 10px 2px ${COLOR_BORDER}
`;

const borderBoxStyle = `
  border : 1px solid ${COLOR_BORDER}
`;

const BoxWrapper = styled.div`
  width: ${({ width }) => width || '500px'};
  height: ${({ height }) => height || '300px'};
  ${({ boxType }) => (boxType === 'blur' ? blurBoxStyle : borderBoxStyle)};
  box-sizing: border-box;
  border-radius: 10px;
`;

const ContentBox = ({ style, className, width, height, children, boxType }) => (
  <BoxWrapper
    style={style}
    className={className}
    width={width}
    height={height}
    boxType={boxType}
  >
    {children}
  </BoxWrapper>
);

ContentBox.propTypes = {
  style: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  boxType: PropTypes.string,
};

export default ContentBox;
